export default function initSearchSuggestion() {
  const containers = document.querySelectorAll(".search-suggestion");
  if (!containers.length) return;

  containers.forEach((container) => {
    const field = container.querySelector(".search-box-field");
    const suggestion = container.querySelector(".search-box-suggestion");
    if (!field || !suggestion) return;

    function toggle() {
      if (field.value.trim().length > 0) {
        suggestion.classList.add("is-open");
      } else {
        suggestion.classList.remove("is-open");
      }
    }

    field.addEventListener("input", toggle);
    field.addEventListener("focus", toggle);

    // Close on click outside
    document.addEventListener("click", (e) => {
      if (!container.contains(e.target)) {
        suggestion.classList.remove("is-open");
      }
    });

    // Close on Escape
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        suggestion.classList.remove("is-open");
      }
    });

    // Close when clear button is clicked
    const closeBtn = container.querySelector(".search-box-close");
    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        suggestion.classList.remove("is-open");
      });
    }
  });
}
